import { Component, ComponentFactoryResolver, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ModalService, ModalSize } from '@cv-invision/core';
import { ExternalApiService } from '../../../../../services/external-api.service';
import { LayoutRenderService } from '../../../../services/layout-render.service';
import { PublicRecordModalComponent } from '../public-record-modal/public-record-modal.component';

@Component({
	selector: 'cv-public-record-field',
	templateUrl: './public-record-field.component.html',
	styleUrls: ['./public-record-field.component.scss']
})
export class PublicRecordFieldComponent implements OnInit, OnDestroy, OnChanges {

	@Input() fieldOptions: any;
	@Input() values: any;
	@Input() saveAndUpdate: Function;

	isMultiple = false;
	PUBLIC_RECORD_MESSAGES_TOOLTIP = {
		none: 'No Properties found',
		multiple: 'Multiple properties found',
		single: '1 property selected'
	}

	private unsubscribe = new Subject<void>();

	constructor(
		private modalService: ModalService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private externalApiService: ExternalApiService,
		private layoutRenderService: LayoutRenderService
	) {

	}

	get isEditing(): boolean {
		return this.layoutRenderService.activateEditableUX;
	}

	ngOnInit(): void {
		this.isMultiple = this.fieldOptions.publicRecordMultiple === 'multiple';
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(changes['fieldOptions'] && !changes['fieldOptions'].firstChange) {
			this.fieldOptions = changes['fieldOptions'].currentValue;
			this.isMultiple = this.fieldOptions.publicRecordMultiple === 'multiple';
		}
	}

	/**
	 * Get public records and send data for open modal
	 */
	openDetailModal(): void {
		if (this.fieldOptions.triggerModal && this.isMultiple && this.isEditing) {
			this.externalApiService.getPublicRecordByOrderId(this.fieldOptions.orderId).subscribe(data => this.openModal(data))
		}

	}

	/**
	 * Invoke modalService open and create the modal component
	 * @param publicRecords array
	 */
	openModal(publicRecords: any[]): void {
		this.modalService.open({
			componentFactoryResolver: this.componentFactoryResolver,
			component: PublicRecordModalComponent,
			data: {
				publicRecords: publicRecords,
				description: this.values.join(this.fieldOptions.charConcat ? this.fieldOptions.charConcat : '/')
			},
			modalConfiguration: {
				defaultFullScreen: true,
				modalSize: ModalSize.XL
			}
		})
		.pipe(takeUntil(this.unsubscribe))
		.subscribe((result) => {
			if (result?.publicRecordId) {
				this.layoutRenderService.componentBroadcast.next({
					eventType: 'PUBLIC_RECORD',
					jsonPath: '',
					metaData: {
						orderID: this.fieldOptions.orderId,
						publicRecordID: result.publicRecordId
					}
				})
			}

		})
	}
}
